import React from 'react';
import BOLayout from '@/pages/back-office/BOLayout';
import DefaultRestaurantSelector from '@/components/DefaultRestaurantSelector';
import { useRestaurantsContext } from '@/contexts/RestaurantContext';
import SettingsTopBanner from '@/components/back-office/SettingsTopBanner';

const DefaultRestaurantPage = () => {
  const { restaurants } = useRestaurantsContext();

  return (
    <BOLayout>
      <SettingsTopBanner />

      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-6">Configuration du restaurant par défaut</h1>
        
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="mb-4">
            Sélectionnez le restaurant qui sera affiché par défaut lorsqu'un utilisateur se connecte à l'application.
          </p>
          
          {restaurants.length === 0 ? (
            <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 p-4 rounded-md">
              Aucun restaurant n'est disponible. Veuillez d'abord créer un restaurant.
            </div>
          ) : (
            <DefaultRestaurantSelector />
          )}
        </div>
      </div>
    </BOLayout>
  );
};

export default DefaultRestaurantPage; 